




















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class DragDropElement extends Vue {
  @Prop({ required: true }) readonly x!: number;
  @Prop({ required: true }) readonly y!: number;
  @Prop({ required: true }) readonly size!: number;
  @Prop({ required: false }) readonly src: string | undefined;

  public id = Math.floor(Math.random() * 100) + '-dd';

  private lastPosX = 0;
  private lastPosY = 0;

  public dragStart(e: any) {
    e.preventDefault();

    this.lastPosX = e.clientX;
    this.lastPosY = e.clientY;

    document.onmousemove = this.move;
    document.onmouseup = this.dragEnd;
  }

  public touchStart(e: any) {
    e.preventDefault();

    this.lastPosX = e.touches[0].clientX;
    this.lastPosY = e.touches[0].clientY;

    document.ontouchmove = this.touchMove;
    document.ontouchend = this.dragEnd;
  }

  public move(e: any) {
    this.updatePosition(e.clientX, e.clientY);
  }

  public touchMove(e: any) {
    this.updatePosition(e.touches[0].clientX, e.touches[0].clientY);
  }

  private updatePosition(clientX: number, clientY: number) {
    const diffX = clientX - this.lastPosX;
    const diffY = clientY - this.lastPosY;

    // @ts-ignore
    this.$refs.draggableThing.style.top = (this.$refs.draggableThing.offsetTop + diffY) + 'px';
    // @ts-ignore
    this.$refs.draggableThing.style.left = (this.$refs.draggableThing.offsetLeft + diffX) + 'px';

    this.lastPosX = clientX;
    this.lastPosY = clientY;
  }

  public dragEnd() {
    document.onmouseup = null;
    document.ontouchend = null;
    document.onmousemove = null;
    document.ontouchmove = null;
  }

  mounted() {
    // @ts-ignore
    this.$refs.draggableThing.style.top = this.y + 'px';
    // @ts-ignore
    this.$refs.draggableThing.style.left = this.x + 'px';

    // @ts-ignore
    document.getElementById(this.id).addEventListener('mousedown', this.dragStart, false);
    // @ts-ignore
    document.getElementById(this.id).addEventListener('touchstart', this.touchStart, false);
  }
}
